import React from "react";
import SEO from "../../components/meta-tags";
import Main from "../../components/candidate_screens/dashboard/main";
const Dashboard = () => {
  return (
    <>
      <SEO title="Dashboard" />
      <Main />
    </>
  );
};

export default Dashboard;
